module.exports = __webpack_public_path__ + "static/visual_2-c938d88bdd71567b1ff83a0da168c89f.jpg";